<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="搜索"
        @search="searchHandle"
      />
    </div>

    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="type"
        color="#d62f2f"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="直播"></van-tab>
        <van-tab title="专题活动"></van-tab>
      </van-tabs>
    </div>

    <div v-if="type == 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getMobileLiveList"
      >
        <div v-for="(item, index) in list" :key="index">
          <mini-program
            class="liveItem"
            :path="
              '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
            "
          >
            <van-image fit="cover" :src="item.Cover" />
            <div class="lit_state">
              <div
                class="lits_text"
                :class="
                  item.Status == 1
                    ? 'orange'
                    : item.Status == 0
                    ? 'red'
                    : 'purple'
                "
              >
                <img
                  src="../../../static/images/index/status.gif"
                  v-if="item.Status == 0"
                />
                <span>{{ item.StatusDesc }}</span>
              </div>
              <div v-if="item.Status == 1" class="lits_time">
                {{ item.StartTimeDesc }}
              </div>
            </div>
            <div class="rightBox">
              <div class="title overFlowTwo">{{ item.Title }}</div>
              <div class="storeBox">
                <van-image
                  fit="cover"
                  :src="item.HeadlineLogo"
                  round
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                />
                <div class="name overFlowOne">{{ item.Headline }}</div>
                <div class="visitBtn" v-if="item.Status == 0">去围观</div>
                <div class="visitBtn" v-if="item.Status == 1">预约</div>
              </div>
            </div>
          </mini-program>
        </div>
      </van-list>

      <div class="noDataBox" v-if="noContentOne">
        <span class="iconfont icon-search"></span>
        <div>暂无内容，换个关键词试试吧</div>
      </div>
    </div>

    <div v-if="type == 1">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getSpecialList"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="liveItem"
          @click.stop="toSpecialDetail(item.SpecialId)"
        >
          <van-image fit="cover" :src="item.Cover" />
          <div class="rightBox">
            <div class="title overFlowTwo">{{ item.Name }}</div>
            <div class="time">
              活动时间：{{ item.StartDateDesc }} - {{ item.EndDateDesc }}
            </div>
          </div>
        </div>
      </van-list>
      <div class="noDataBox" v-if="noContentTwo">
        <span class="iconfont icon-search"></span>
        <div>暂无内容，换个关键词试试吧</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import miniProgram from "@/components/miniProgram";
import { Search, Tab, Tabs, Image, List } from "vant";
import { mobileLiveList, liveSpecialList } from "@/api/online";
export default {
  name: "liveSearch",
  components: {
    "van-search": Search,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-list": List,
    miniProgram,
  },
  data() {
    return {
      type: 0, //0直播 1专题
      keyword: "",
      list: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,

      pageIndex: 1,
      total: 0,
      noContentOne: false, //暂无内容1
      noContentTwo: false, //暂无内容2
    };
  },
  methods: {
    toSpecialDetail(id) {
      this.$router.push({ path: "/specificActDetail", query: { sid: id } });
    },

    searchHandle() {
      if (this.trim(this.keyword)) {
        this.pageIndex = 1;
        this.list = [];
        if (this.type == 0) {
          this.getMobileLiveList();
        } else {
          this.getSpecialList();
        }
      }
    },

    //去除首尾的空格
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    typeClick(name) {
      this.type = name;
      this.pageIndex = 1;
      this.list = [];
      this.loading = true;
      if (this.loading) {
        if (this.type == 0) {
          this.getMobileLiveList();
        } else {
          this.getSpecialList();
        }
      }
    },

    getMobileLiveList() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
        Status: -1,
      };
      mobileLiveList(data)
        .then((res) => {
          var list = res.Data.List;
          list.forEach((item, index) => {
            item.StartTimeDesc = item.StartTimeDesc.substr(5).replace(
              /-/g,
              "/"
            );
          });
          if (res.Data.List.length == 0) {
            this.noContentOne = true;
          }
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    getSpecialList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        IsRec: 0,
        Keyword: that.keyword,
      };
      liveSpecialList(data)
        .then((res) => {
          if (res.Data.List.length == 0) {
            this.noContentTwo = true;
          }
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          // 加载状态结束
          that.loading = false;
          // 数据全部加载完成
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },

  mounted() {
    this.keyword = this.$route.query.keyword;
    getShareData(
      window.location.href,
      "2022阿拉丁网上照明展直播和专题活动中心"
    );
  },
};
</script>
<style lang="less" scoped>
.classifyNav {
  font-size: 14px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 0;
  .van-tab {
    flex: inherit !important;
    -webkit-flex: inherit !important;
    width: 80px !important;
    font-size: 14px !important;
  }
  /deep/ .van-tab--active {
    font-weight: bold;
  }
  /deep/.van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }
}
</style>